import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg mb-4">哔咔漫画指南</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              哔咔漫画官方指南 —— 为二次元爱好者提供最全面的哔咔下载、注册、使用教程，帮助你快速上手哔咔漫画，畅享正版漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/xiazai-jiaocheng" className="text-sm text-background-400 hover:text-primary-400 transition-colors">下载教程</Link>
              </li>
              <li>
                <Link to="/category/zhuce-zhinan" className="text-sm text-background-400 hover:text-primary-400 transition-colors">注册指南</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">热门文章</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/bika-android-xiazai-jiaocheng" className="text-sm text-background-400 hover:text-primary-400 transition-colors">安卓版下载教程</Link>
              </li>
              <li>
                <Link to="/article/bika-ios-xiazai-an-zhuang" className="text-sm text-background-400 hover:text-primary-400 transition-colors">iOS版安装指南</Link>
              </li>
              <li>
                <Link to="/article/bika-zhuce-jiaocheng-xiangjie" className="text-sm text-background-400 hover:text-primary-400 transition-colors">注册流程详解</Link>
              </li>
              <li>
                <Link to="/article/bika-wufa-dakai-jiejue" className="text-sm text-background-400 hover:text-primary-400 transition-colors">常见问题解决</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center space-x-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                <span>support@bika-comic.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </span>
                <span>官方微信公众号：哔咔漫画</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                <span>官方微博：@哔咔漫画官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 哔咔漫画指南. 本站为哔咔漫画非官方教程网站，仅供学习参考。
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;